import { Button, Flex, Modal, Row, Space } from "antd";
import TableAntd from "components/elements/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";
import { ReactComponent as YesIcon } from "../../../assets/icon/yesCircle.svg";
import { ReactComponent as NoIcon } from "../../../assets/icon/noCircle.svg";
import dayjs from "dayjs";
import { useCallback } from "react";

const MyTimesheetDetailModal = ({
    open = false,
    setIsModalOpen = () => { },
    selectedCell = null,
    timesheetByDay = [],
    isTeamTimesheet = false,
    employeeName = "",
    isLoading = false
}) => {
    const { t, i18n } = useTranslation();

    const totalWorkingMinutes = timesheetByDay.reduce((total, record) => {
        return total + ((record.totalWorkingHours || 0) * 60 + (record.totalWorkingMinutes || 0));
    }, 0);

    const totalHours = Math.floor(totalWorkingMinutes / 60);
    const totalMinutes = String(totalWorkingMinutes % 60).padStart(2, '0');

    const columns = [
        {
            title: <div className="text-table" >{t("my_timesheet.label.dateTimeRecord")}</div>,
            dataIndex: "recordingDate",
            key: "recordingDate",
            width: 120,
            render: (_, record) => (
                dayjs(record?.recordingDate).format(i18n.language == "en" ? "DD/MM/YYYY" : "DD/MM/BBBB")
            )
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.project")}</div>,
            dataIndex: "projectName",
            key: "projectName",
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.roles")}</div>,
            dataIndex: "roleName",
            key: "roleName",
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.task")}</div>,
            dataIndex: "taskName",
            key: "taskName"
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.number_of_working_hour")}</div>,
            dataIndex: "totalWorkingHours",
            key: "totalWorkingHours",
            align: "center",
            width: 120,
            render: (_, record) => (
                `${record?.totalWorkingHours ?? "0"} ${t("unit.hours")} ${record?.totalWorkingMinutes ?? "0"} ${t("unit.minute_0")}`
            )
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.details")}</div>,
            dataIndex: "description",
            key: "description",
            width: 150,
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.billable")}</div>,
            dataIndex: "billableFlag",
            key: "billableFlag",
            align: "center",
            width: 100,
            render: (_, record) => {
                if (record?.billableFlag === "Y") {
                    return <YesIcon />;
                } else if (record?.billableFlag === "N") {
                    return <NoIcon />;
                } else {
                    return null;
                }
            }
        },
        {
            title: <div className="text-table" >{t("my_timesheet.label.status")}</div>,
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (_, record) => {
                return (
                    <StatusTag
                        value={i18n.language == "en" ? record?.approveStatusEn : record?.approveStatus}
                        text={i18n.language == "en" ? record?.approveStatusEn : record?.approveStatus}
                    />
                )
            }
        }
    ]

    const modal = useCallback(
        () => {
            return <Modal
                open={open}
                title={
                    <span style={{ color: "#667085" }}>
                        {t("my_timesheet.label.more_details")}
                    </span>
                }
                footer={null}
                closable={false}
                maskClosable={false}
                width={"75vw"}
            >
                <Space size={24} direction="vertical" style={{ width: "100%" }}>
                    {isTeamTimesheet &&
                        <Flex gap={8}>
                            <span style={{ color: "#667085" }}>{`${t("employee.label.name")} :`}</span>
                            <span style={{ color: "#667085", fontWeight: "bold" }}>{employeeName}</span>
                        </Flex>
                    }
                    <TableAntd
                        columns={columns}
                        dataSource={timesheetByDay}
                        loading={isLoading}
                    />
                    <Flex vertical style={{ alignItems: "end", rowGap: "16px" }}>
                        <Row style={{ gap: "8px" }}>
                            <span style={{ color: "#667085", fontWeight: "bold" }}>{`${t("my_timesheet.label.total_working_hours")} :`}</span>
                            <span style={{ color: "#667085" }}>{`${totalHours}:${totalMinutes} ${t("unit.hour")}`}</span>
                        </Row>
                        <Button onClick={() => { setIsModalOpen(false) }} type="primary" style={{ width: "max-content", borderRadius: "8px ", backgroundColor: "var(--button-color)" }} size="large">
                            {t("common.close")}
                        </Button>
                    </Flex>
                </Space>
            </Modal>
        },
        [selectedCell, open, columns, timesheetByDay],
    )

    return (
        modal()
    )
}

export default MyTimesheetDetailModal;